module.exports = __webpack_public_path__ + "static/img/4.bd2a25b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/4.png
// module id = JQZP
// module chunks = 0